require('../icons/icons');
import initMenu from './modules/menu';
/**
 *  App object
 *
 *  The app object functions a the main back-bone of the javascript used in this
 *  project and will be bound to window.
 *
 */
const app = {
    testimonialSlider: () => {
        import('./modules/testimonial-slider').then((module) => {
            module.default();
        });
    },
    gallerySlider: () => {
        import('./modules/gallery-slider').then((module) => {
            module.default();
        });
    },
    playYoutubeVideo: (youtubeVideoId) => {
        import('./modules/play-youtube-video').then((module) => {
            module.default(youtubeVideoId);
        });
    },
    onDocumentReady: (fn) => {
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            // call on next available tick
            setTimeout(fn, 1);
        }
        else {
            document.addEventListener('DOMContentLoaded', function () {
                setTimeout(fn, 1);
            });
        }
    }
};
function init() {
    initMenu();
    if (document.getElementsByClassName('testimonial-slider').length) {
        app.testimonialSlider();
    }
    if (document.getElementsByClassName('gallery').length) {
        app.gallerySlider();
    }
    // Init code here
}
app.onDocumentReady(init);
window.app = app;
